export default "__VITE_ASSET__CHPQ9_T2__"